import { createApiCall } from 'lib/base';

const POST_INVESTCORE_EMPLOYEE_PROGRAM_CREATE_EMPLOYEE_SELL_ORDER_API_ID =
  'DASHBOARD/POST_INVESTCORE_EMPLOYEE_PROGRAM_CREATE_EMPLOYEE_SELL_ORDER_API_ID';

const apiCall = createApiCall(
  POST_INVESTCORE_EMPLOYEE_PROGRAM_CREATE_EMPLOYEE_SELL_ORDER_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/create-employee-sell-order`,
    method: 'POST',
    isStay: true,
    notify: true,
    body: payload,
  })
);

export default apiCall;
